 import Vapi from '@vapi-ai/web';

 let vapiInstance = null;

 export const getVapi = () => {
   if (!vapiInstance) {
     const apiKey = process.env.REACT_APP_VAPI_API_KEY;
     if (!apiKey) {
       throw new Error('REACT_APP_VAPI_API_KEY is not set');
     }
     vapiInstance = new Vapi(apiKey);
   }
   return vapiInstance;
 };

export const startAssistant = async (assistantId, { feedbackId, traineeId, traineeName, traineeEmail, callType, customerMood, issue, token, score, feedback } = {}) => {
  const vapi = getVapi();
  const id = assistantId;
  if (!id) {
    throw new Error('Assistant ID is not set');
  }
  // Attach contextual metadata if supported by Vapi SDK (commonly via setEnvironment or similar)
  try {
    if (vapi?.setEnvironment) {
      await vapi.setEnvironment({ feedbackId, traineeId, traineeName, traineeEmail, callType, customerMood, issue, token, score, feedback });
    }
  } catch (_) {}
  return vapi.start(id, {
    // Request provider-side recording so both call sides are captured reliably.
    recordingEnabled: true,
    variableValues: {
      feedbackId,
      traineeId,
      traineeName,
      traineeEmail,
      callType,
      customerMood,
      issue,
      score,
      feedback
    }
  });
};

 export const stopAssistant = async () => {
   const vapi = getVapi();
   if (vapi?.stop) return vapi.stop();
 };


